"use client"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  useTheme,
  Avatar,
} from "@mui/material"
import LaunchIcon from "@mui/icons-material/Launch"
import DiscordIcon from "@mui/icons-material/Chat"
import config from "../config"

const ContactModal = ({ open, onClose }) => {
  const theme = useTheme()
  const DISCORD_INVITE_LINK = config.DISCORD_INVITE_LINK || "https://discord.gg/4Sy9nGasJV"
  const OWNER_DISCORD_LINK = "https://discord.com/users/425436301047627806"
  const OWNER_AVATAR = "https://cdn.discordapp.com/avatars/425436301047627806/ddf92daef47c355954e73d2a0e72188a.png"

  const handleOpenDiscordProfile = () => {
    window.open(OWNER_DISCORD_LINK, "_blank", "noopener,noreferrer")
  }

  const handleJoinDiscord = () => {
    window.open(DISCORD_INVITE_LINK, "_blank", "noopener,noreferrer")
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: "rgba(13, 15, 25, 0.95)",
          border: "1px solid rgba(0, 229, 255, 0.2)",
          borderRadius: 2,
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
          overflow: "hidden",
          maxWidth: "500px",
          width: "100%",
        },
      }}
    >
      {/* Decorative header */}
      <Box
        sx={{
          height: "8px",
          background: "linear-gradient(90deg, #00e5ff 0%, rgba(0, 229, 255, 0.3) 50%, rgba(0, 0, 0, 0) 100%)",
          width: "100%",
        }}
      />

      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          pb: 1,
        }}
      >
        <Typography variant="h6" component="span" sx={{ fontWeight: "bold" }}>
          Contact the Developer
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            mb: 3,
          }}
        >
          <Avatar
            src={OWNER_AVATAR}
            alt="Tawaret"
            sx={{
              width: 80,
              height: 80,
              border: "2px solid rgba(0, 229, 255, 0.5)",
              boxShadow: "0 0 10px rgba(0, 229, 255, 0.3)",
            }}
          />
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            tawaret_
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.7)" }}>
            @Tawaret
          </Typography>
        </Box>

        <DialogContentText sx={{ color: "rgba(255, 255, 255, 0.8)", mb: 3, textAlign: "center" }}>
          The best way to contact the developer is through Discord. You can either message directly or join the Discord
          server for community support.
        </DialogContentText>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="contained"
            onClick={handleOpenDiscordProfile}
            endIcon={<LaunchIcon />}
            fullWidth
            sx={{
              background: "linear-gradient(45deg, #5865F2 30%, #7289DA 90%)",
              boxShadow: "0 0 10px rgba(88, 101, 242, 0.5)",
              "&:hover": {
                boxShadow: "0 0 15px rgba(88, 101, 242, 0.8)",
                background: "linear-gradient(45deg, #4752c4 30%, #5d73c7 90%)",
              },
            }}
          >
            Open Discord Direct Message
          </Button>

          <Button
            variant="outlined"
            onClick={handleJoinDiscord}
            startIcon={<DiscordIcon />}
            fullWidth
            sx={{
              borderColor: "rgba(88, 101, 242, 0.5)",
              color: "#5865F2",
              "&:hover": {
                borderColor: "#5865F2",
                backgroundColor: "rgba(88, 101, 242, 0.1)",
              },
            }}
          >
            Join Discord Server
          </Button>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: "rgba(255, 255, 255, 0.3)",
            color: "rgba(255, 255, 255, 0.7)",
            "&:hover": {
              borderColor: "rgba(255, 255, 255, 0.5)",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ContactModal
